export default __webpack_public_path__ + "static/media/best-cat.c152c543.svg";